import PageTitle from "../MainContents/PageTitle/PageTitle";
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import Flow from "./Flow";


const Main =styled.div`
    margin-top: 100px;
    width: 90%;
    margin: auto;
    @media ${device.mobile}{
        width: 95%;
        position: relative;
    }
`
const Header =styled.h2`
    padding: 15px;
    font-size: 1.5rem;
    background-color: orange;
    color: rgb(255, 255, 255);
    border-radius: 7px;
`
const Mt =styled.div`
margin-top:130px;
@media ${device.mobile}{
  margin-top:80px;
  }
`;
const Join: React.VFC = () => {
  return (
    <Main>
      <ScrollToTopOnMount />
         <Mt></Mt>
      <PageTitle title={'入会の流れ'} englishText={'Join&Flow'} />
      <Header>入会の流れ</Header>
      <Flow id={'1'} title={'お問い合わせ'} content={'お電話・メール・お問い合わせフォームからご連絡ください。'} />
      <Flow id={'2'} title={'体験レッスン'} content={'実際のレッスンを体験して、内容や雰囲気を体感してください。'} />
      <Flow id={'3'} title={'ご検討'} content={'ご家庭で話し合っていただき、入会するかどうかをお決めください。'} />
      <Flow id={'4'} title={'入会'} content={'入会申込書の提出等、各種手続きが完了次第、入会となります。'} />
    </Main>
    
  );
}
export default Join;